{
  // showcase-carousel: the arched image is a fixed-proportion portrait (sized in CSS,
  // matching live) — not a viewport-edge breakout, so no JS width sizing here.
  // On mobile the image naturally falls below the copy + arrows (it's a sibling after the
  // wrapper in the column) — no DOM reorder needed; CSS hides the thumbnails there.

  // keep the main image slider and the thumbnail nav in lockstep: advancing either moves
  // both; only move the other slider when it isn't already on that index
  // read the intended index from slick's API, not the DOM — during a fade transition the
  // .slick-current class lags, and a stale read makes the synced sliders ping-pong back to 0
  const sliderIndex = slider => {
    try { return slider.$slick.slick('slickCurrentSlide') } catch (e) { return 0 }
  }
  const syncCarousels = () => {
    document.querySelectorAll('.showcase-carousel').forEach(block => {
      const imageSlider = block.querySelector('.showcase-carousel--carousel ada-slider')
      const textSlider = block.querySelector('.showcase-carousel--copy')
      if (!imageSlider || !textSlider) return

      const link = (source, target) => {
        jQuery(source).on('afterChange', (e, slick, current) => {
          if (sliderIndex(target) !== current) target.goToSlide(current)
        })
      }
      link(imageSlider, textSlider)
      link(textSlider, imageSlider)
    })
  }

  window.addEventListener('load', syncCarousels)
}
